import { GSC_MAX_COMPARE_DOMAINS } from "@/types/gsc";

export const GSC_COMPARE_DOMAINS_STORAGE_KEY = "gsc_compare_last_domains";

const sanitizeDomains = (value: unknown): string[] => {
  if (!Array.isArray(value)) return [];

  return value
    .filter((item): item is string => typeof item === "string")
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, GSC_MAX_COMPARE_DOMAINS);
};

/** Returns sanitized domains, or `null` when nothing valid is stored. */
export const readStoredCompareDomains = (): string[] | null => {
  try {
    const raw = sessionStorage.getItem(GSC_COMPARE_DOMAINS_STORAGE_KEY);
    if (raw == null) return null;
    const domains = sanitizeDomains(JSON.parse(raw) as unknown);
    return domains.length > 0 ? domains : null;
  } catch {
    return null;
  }
};

export const writeStoredCompareDomains = (
  domains: readonly string[],
): void => {
  try {
    sessionStorage.setItem(
      GSC_COMPARE_DOMAINS_STORAGE_KEY,
      JSON.stringify(sanitizeDomains(domains)),
    );
  } catch {
    // Private mode / quota — ignore.
  }
};
